import { formatAddress } from "../../../format";
import { useTranslation } from "react-i18next";

export default function Address({ address, complements = false }) {
  const { i18n } = useTranslation();

  return (
    <ul
      style={{
        margin: "0",
        overflow: "hidden",
        fontSize: "small",
      }}
    >
      {formatAddress(address, i18n.resolvedLanguage, complements).map(
        (addressLine, index) => (
          <li
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            key={index}
          >
            {addressLine}
          </li>
        ),
      )}
    </ul>
  );
}
